<template>
	<div class="firstPage">
		<el-scrollbar id="menuWarpper" style="height:calc(100%);">
			<el-main>
				<div class="header" ref="header">
					<div class="headerTop">
						<div class="header-con">
							<el-button type="danger" @click="piliangshanchu()" :disabled="isQuanBuShanChu">全部删除</el-button>
						</div>

					</div>
				</div>
				<div class="maina" v-bind:style="{height:EchartsHeight}">
					<el-table :data="tableData" height="100%" highlight-current-row resizable stripe border>
						<el-table-column align="center" type="selection" label="序号" width="50">
						</el-table-column>
						<el-table-column align="center" type="index" label="序号" width="50" show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="ID" label="编号" width="150" show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="CODE" label="工单号" width="150" show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column align="center" prop="INFO_STATUS1" label="工单状态" show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="UPDATED_TIME" label="更新时间" width="150"
							show-overflow-tooltip>
							<template v-if="scope.row.UPDATED_TIME!=null" slot-scope="scope">
												{{scope.row.UPDATED_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}
													
											</template>
						</el-table-column>
						<el-table-column align="center" prop="Message" label="消息内容" width="400" show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" prop="ACCOUNT" label="接收账号" width="100"
							show-overflow-tooltip>
						</el-table-column>
						<el-table-column align="center" label="操作" fixed="right" width="100px" show-overflow-tooltip>
							<template slot-scope="scope">
								<el-button type="primary" @click="viewDoc(scope)">查看</el-button>
								<!-- <el-button type="success" @click="pingjia(scope.$index)">评价</el-button> -->
							</template>
						</el-table-column>


					</el-table>
				</div>
				<div class="footer" ref="footer">
					<pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanSiChange="hanSiChange"
						@hanCurrChange="hanCurrChange"></pagination>
				</div>
			</el-main>
		</el-scrollbar>

	</div>
</template>

<script>
	export default {
		name: "tuisong",
		data() {
			return {
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				xingji: 4,
				miaoshu: "",
				pingjiaxuanzhong: 0,
				formDialog: false,
				formxjgdlog: false,
				formxzkhlog: false,
				chanpinxian: "", //产品线
				colors: ['#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00'],
				staffcopy: [],
				staff: [], //产品线
				staffz: [], //产品线
				kehumingcheng: "",
				templateName: "",
				kaishishijian: "",
				jieshushijian: "",
				loading: false,
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				value: "",
				shijian: "",
				tableData: [],
				WenTileixingList: [],
				sfdycjr: 0,

			};
		},

		mounted() {

			const that = this;
			window.onresize = () => {
				// return (() => {
					window.screenHeight = document.body.clientHeight
					that.EchartsHeight = (window.screenHeight - 200) + 'px'
					that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
				// })()
			}

			this.currPage = 1;
			this.ChaXun(this.currPage);

		},
		activated() {
			const that = this;
			window.onresize = () => {
				// return (() => {
					window.screenHeight = document.body.clientHeight
					that.EchartsHeight = (window.screenHeight - 200) + 'px'
					that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
				// })()
			}
			
			this.currPage = 1;
			this.ChaXun(this.currPage);
			
		},
		beforeRouteEnter(to, form, next) {
			next(vm => {
				vm.ChaXun(1)

			})

		},
		methods: {
			//查询
			ChaXun(index) {
				this.currPage = index;
				this.loading = true;

				this.$request({
						method: "GET",
						url: '/Socket/AccountMsg?pageIndex=' + encodeURIComponent(index) + "&pageSize=" +
							encodeURIComponent(this
								.pageSize)
					})
					.then((res) => {

						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.tableData = res.Data;
							if (this.tableData.length > 0) {
								for (var i in this.tableData) {
									if (this.tableData[i].INFO_STATUS == 0) {
										this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
									} else if (this.tableData[i].INFO_STATUS == 1) {
										this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
									} else if (this.tableData[i].INFO_STATUS == 2) {
										this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
									} else if (this.tableData[i].INFO_STATUS == 3) {
										this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
									} else if (this.tableData[i].INFO_STATUS == 4) {
										this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
									} else if (this.tableData[i].INFO_STATUS == 5) {
										this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
									}
								}
							}
						}
						this.allPage = res.Total;
					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});

			},


			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun(this.currPage);
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},


		},
	};
</script>

<style scoped>
	.firstPage {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		/* padding: 20px; */
		padding-left: 0px;
		background-color: #F0F0F0;
	}

	.el-main {
		background-color: #F0F0F0;
		padding: 0px;
	}


	/* 头部选择模板名称 */
	.header {
		height: 60px;
		background-color: #FFFFFF;
		padding-left: 20px;
		padding-top: 20px;
		/* width: calc(100%-10px); */
	}

	.headerTop {
		display: flex;
		justify-content: space-between;
	}

	.header-con {
		height: 40px;
		/* width: calc(100%-200px); */
		display: flex;
		align-items: center;
	}

	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}

	.headerpingjia {
		margin-bottom: 0;
		text-align: center;
		width: 100%;
		font-size: 20px;

	}





	.list {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		width: 100%;
		height: 100%;
	}

	.item {
		width: 100%;
		height: 100%;
	}

	.itema {
		margin-top: 10px;
		box-sizing: border-box;
		width: 100%;
		border-radius: 4px;
		height: 30px;
	}

	.itemb {
		margin-top: 10px;
		box-sizing: border-box;
		width: 100%;
		border-radius: 4px;
		margin-bottom: 0px;
		bottom: 0px;
	}

	.fankuiImage {
		width: 100%;
		height: 100%;



	}

	.itemaBoxa {
		float: left;
		margin-top: 3px;
		margin-left: 0px;
		margin-left: 4px;
		width: 100px;
		height: 30px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 25px;
		color: #000000;
		opacity: 1;
	}

	.itemaBoxb {
		float: left;
		margin-top: 0px;
		margin-left: 20px;
		width: 200px;
		height: 20%;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 25px;
		color: #000000;
		opacity: 1;
	}

	.itemaBoxc {
		float: left;
		margin-top: 0px;
		margin-left: 20px;
		width: 100px;
		height: 20%;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 25px;
		color: #000000;
		opacity: 1;
	}

	.itemBox {
		box-sizing: border-box;
		width: 100%;
		border: 1px solid #ebeef5;
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		height: 80px;
	}

	.itemBoxa {
		float: left;
		top: 20px;
		left: 0px;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}

	/deep/ .el-dialog {
		max-height: 80%;
	}

	.itemBoxb {
		float: left;
		top: 20px;
		left: 20%;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}

	.itemBoxc {
		float: left;
		top: 20px;
		left: 40%;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}

	.itemBoxd {
		float: left;
		top: 20px;
		left: 60%;
		margin-left: 4px;
		width: 20%;
		height: 20%;
	}


	.itemTop {
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 80px;
		padding: 0 25px;
		/* border-bottom: 1px solid #F2F4F9; */
	}

	.itemTopText {
		float: left;
		width: 80px;
		height: 22px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 25px;
		color: #000000;
		opacity: 1;
		margin-left: 10rpx;
	}

	.sousuoyou {
		float: right;
		margin-top: 20px;
		/* right: 30px; */
		margin-right: 20px;
		width: 92px;
		height: 36px;
		font-size: 16px;
		line-height: 18px;
		text-align: center;
		/* width: 100%;
  height: 100%; */
		overflow: hidden;
		/* background-color: #fff; */
	}

	.container {
		width: 100%;
		height: 100%;
		box-sizing: border-box;

	}


	/* 主体容器 */
	.main {
		margin-top: 10px;

		overflow-y: auto;
		margin-right: 0px;
	}

	/* 主体容器 */
	.maina {
		margin-top: 10px;
		overflow-y: auto;
		margin-right: 0px;
	}

	.yemakuandu {
		width: 99%;
		background-color: #fff;
		height: 40px;
		padding-top: 20px;
	}

	/**输入框宽度 */
	.input {
		width: 200px;
	}

	/**dialog中样式 */
	.dialog-con {
		height: 375px;
		overflow: auto;
	}

	/**dialog中样式 */
	.dialog-cona {
		height: auto;
		overflow: auto;
	}

	.itemc {
		margin-top: 10px;
		box-sizing: border-box;
		width: 100%;
		margin-bottom: 10px;
		/* height: 98%; */
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		overflow-y: auto;
	}

	.itemcBoxa {
		width: 49.95%;
		height: 70px;
		max-height: 100px;
		float: none;

		background-color: #fff;
	}

	.itemd {
		box-sizing: border-box;
		width: 100%;
		height: 98%;
		background-color: #fff;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		overflow-y: auto;
	}

	.itemdtext {
		margin-left: 10px;
		margin-top: 20px;
		margin-bottom: 10px;
		width: 80%;
		height: 22px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 22px;
		color: #181818;
		opacity: 1;
		text-decoration: underline;
	}

	.itemdtexta {
		margin-left: 10px;
		margin-top: 20px;
		margin-bottom: 10px;
		width: 16%;
		height: 22px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 22px;
		color: #181818;
		opacity: 1;
		text-decoration: underline;
	}

	/**底部分页 */
	.footer {
		height: 50px;
		margin-right: 0px;
	}

	.taiyangImage {

		display: flex;
		justify-content: center;
		align-items: center;
	}

	.taiyangImagez {
		margin: 10px;
		width: 92px;
		height: 92px;
	}

	.fuwuxingjiwz {
		height: 40px;
		line-height: 60px;
	}

	.fuwuxingjiwza {
		height: 140px;
		margin-top: -20px;
		font-size: 16px;
	}

	/deep/.el-rate__icon {
		font-size: 40px;
	}

	/deep/ .iconyishoucang {
		color: #FFFF00;
		font-size: 22px;
	}

	/deep/ .iconshoucang {
		color: #bbb;
		font-size: 22px;
	}

	.headermiaoshu {
		margin-bottom: 0;
		margin-top: 20px;
		margin-left: 25%;
		width: 70%;
		font-size: 16px;
		color: #666666;
	}

	/**输入框宽度 */
	.form-item-input {
		width: 450px;
	}

	/**输入框宽度 */
	.form-item-inputcpx {
		width: 180px;
	}

	.headerfueuxingji {
		margin-bottom: 0;
		margin-top: 0;
		margin-left: 25%;
		width: 50%;
		font-size: 16px;
		color: #666666;
	}




	.containera {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		margin-top: -10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	.headerxjgd {
		margin-top: 10px;
		margin-bottom: 15px;
		padding-left: 20px;
	}

	.headeraxjgd {
		margin-bottom: 2px;
	}



	.fanhuiBtnxjgd {
		margin-top: 0px;
		margin-left: 0px;
		margin-bottom: 20px;
		display: inline-block;
	}



	.yonghuminglabexjgd {
		margin-top: 0px;
		margin-left: 90px;
		margin-bottom: 20px;
		display: inline-block;
	}

	/* 主体容器 */
	.mainxjgd {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 0px;
		box-sizing: border-box;
	}

	/* 主体容器 */
	.mainxjgda {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 0px;
		margin-top: 20px;
		box-sizing: border-box;
	}

	.tijiaobtnxjgd {
		/* display: flex; */
		margin-top: 30px;
		margin-left: 50%;
		text-align: center;
		/* margin-left: 100px; */
		width: 100px;
	}

	.header-conxjgd {
		margin-left: 0px;
	}

	.header-conaxjgd {
		display: flex;
		align-items: center;
		height: 30px;
		margin-left: 30px;
	}


	.header-con-formxjgd {
		display: flex;
		align-items: center;
	}

	.header-con-form-itemxjgd {
		margin-bottom: 0;
	}

	/**输入框宽度 */
	.form-item-inputxjgd {
		width: 470px;
	}

	/**输入框宽度 */
	.form-item-inputxjgdms {
		width: 1149px;
	}

	/**输入框后面的备注 */
	.form-item-tipxjgd {
		display: inline-block;
		margin-left: 10px;
		color: #606266;
		font-size: 14px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatarxjgd {
		width: 178px;
		height: 178px;
		display: block;
	}

	.shangchuantupianxjgd {
		margin-left: 90px;
		margin-bottom: 20px;
		width: 1149px;



	}

	.shangchuantupianxxjgd {
		margin-left: 10px;
		margin-top: 10px;

		display: inline-block;
	}

	.mediumxjgd {
		width: 470px;
		height: 30px;
		text-align: left;
		color: #999999;
		font-weight: 400;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}

	/deep/ .el-select__tags {

		flex-wrap: nowrap;
		overflow: hidden;
	}
	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
